<template>
  <div>
    <router-view/>
  </div>
</template>

<script>
import cookies from 'js-cookie'
import { setCookieForYear } from '@/utils/utils'

export default {
  created () {
    // 임시 사용자 정보데이터
    // setCookieForYear('LanguageCode', 'ko');
    // setCookieForYear('CountryCode', '82');
    // setCookieForYear('AppType', 'IOS');
    // setCookieForYear('AppVersion', '2.4');
    // setCookieForYear('UID', '1895_NoEqupiMB');
    // setCookieForYear('USER_LAST_DATETIMES', '2022-08-10 10:45:09');
    // setCookieForYear('UTCInterval', '-540');
    // setCookieForYear('UserGender', 'M');;

    const urlParams = new URLSearchParams(window.location.search)
    let uid = urlParams.get('uId');
    if (uid !== undefined && uid !== null) setCookieForYear('UID', uid);
    let appType = urlParams.get('appType');
    if (appType !== undefined && appType !== null) setCookieForYear('AppType', appType);
    let appVersion = urlParams.get('appVersion');
    if (appVersion !== undefined && appVersion !== null) setCookieForYear('AppVersion', appVersion);
    let language = urlParams.get('language');
    if (language !== undefined && language !== null) setCookieForYear('LanguageCode', language);
    let country = urlParams.get('country');
    if (country !== undefined && country !== null) setCookieForYear('CountryCode', country);
    let utc = urlParams.get('utc');
    if (utc !== undefined && utc !== null) setCookieForYear('UTCInterval', utc);
    let datetimes = urlParams.get('datetimes');
    if (datetimes !== undefined && datetimes !== null) setCookieForYear('USER_LAST_DATETIMES', datetimes);
    else setCookieForYear('USER_LAST_DATETIMES', datetimes);
    let gender = urlParams.get('gender');
    if (gender !== undefined && gender !== null) setCookieForYear('UserGender', gender);
    let whereToUseCode = urlParams.get('whereToUseCode');
    if (whereToUseCode !== undefined && whereToUseCode !== null) setCookieForYear('WhereToUseCode', whereToUseCode);
    let userNickName = urlParams.get('userNickName');
    if (userNickName !== undefined && userNickName !== null) setCookieForYear('UserNickName', userNickName);

    //B2B 전용 설정
    let challengeId = urlParams.get('challengeId');
    if (challengeId !== undefined && challengeId !== null) setCookieForYear('ChallengeId', challengeId);
    let cuId = urlParams.get('cuId');
    if (cuId !== undefined && cuId !== null) setCookieForYear('CuId', cuId);
    let goalUITypeCode = urlParams.get('GoalUITypeCode');
    if (goalUITypeCode !== undefined && goalUITypeCode !== null) setCookieForYear('GoalUITypeCode', goalUITypeCode);
    else {
      setCookieForYear('GoalUITypeCode', '');
    }

    let languageCode = cookies.get('LanguageCode');
    this.$i18n.locale = languageCode === undefined ? 'ko' : languageCode;
  },
  mounted () {
    console.log('App.vue mounted');
  },
}
</script>

<style>
@import './assets/css/normalization.css';
/* #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
} */

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>